import React from 'react';
import SuspenseWrapper from '../../modules/SuspenseWrapper/SuspenseWrapper';
import RemoteSubmissionWrapper from './RemoteSubmissionWrapper';
import { UnsavedChangesProvider } from '../../modules/UnsavedChanges/UnsavedChangesProvider';
const RemoteSubmissionPage = () => (React.createElement(SuspenseWrapper, null,
    React.createElement(UnsavedChangesProvider, null,
        React.createElement(RemoteSubmissionWrapper, null))));
export default RemoteSubmissionPage;
